import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function hlm(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
